import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getExchangeById as getById,
  resetForm as reset,
  modifyExchange as modify,
  addExchange as add,
  updateExchange as update,
  getFormConfig,
} from 'exchange/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

import { getEditing } from 'exchange/selectors';
import { getCompany } from 'auth/selectors';

import { valueFromEvent } from 'lib/util';

class ExchangeFormHandlers extends Component {
  static propTypes = {
    render: Proptypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false };

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  handleValidation = (isValid) => this.setState({ isValid });

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.exchange.id
          ? this.props.update(this.props.exchange.id, this.props.company.id, this.props.exchange)
          : this.props.add(this.props.company.id, this.props.exchange);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(`/companies/${this.props.company.id}/exchange`);
          })
          .catch((err) => {
            this.finishSaving();
            this.props.error(err.message);
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  componentWillMount = () => {
    const { iId } = this.props.match.params;
    this.props.reset();
    this.props.getFormConfig(this.props.company.id);
    iId && this.props.getById(iId, this.props.company.id);
  };

  render = () =>
    this.props.render({
      isSubmitted: this.state.isSubmitted,
      isSaving: this.state.isSaving,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  exchange: getEditing(state),
  company: getCompany(state),
});
const mapDispatchToProps = { reset, getById, modify, add, update, error, success, getFormConfig };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExchangeFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/containers/ExchangeFormHandlers.js